var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Table } from '@dixa/lib-shared-habla';
import { ActionsMenu } from './actionsMenu';
import style from './style.module.scss';
export function MessengerRow(_a) {
    var { messengerName } = _a, rest = __rest(_a, ["messengerName"]);
    return (_jsxs(Table.Tr, { children: [_jsx(Table.Td, Object.assign({ className: style.messengerNameCell, onClick: rest.onEditSettings }, { children: messengerName })), _jsx(Table.Td, Object.assign({ align: "right" }, { children: _jsx(ActionsMenu, Object.assign({}, rest)) }))] }));
}
